<template>
    <v-container fluid class="fill-height" >
        <!-- <TheNavigationPanel/> -->
        <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
            <span>Incorrect Login Details</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" :timeout="10000" top color="red">
            <span>{{snackmsg}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row justify-center align="center" justify="center" no-gutters >
            <v-col cols="12" sm="12" md="12">
                <v-card class="pa-8 mt-8 mx-auto" id="login" max-width="450px" elevation="7">
                    <div class="text-center mt-5" style="color:#1a00d4">Log in to your account</div>
                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field outlined dense label="Email"  prepend-inner-icon="mdi-account" name="username" v-model="username" type="text" color="#1a00d4" :rules="usernameRules">

                            </v-text-field>
                            <v-text-field outlined dense class="mt-7" label="Password" name="password" v-model="password"
                                :append-icon="show1 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                prepend-inner-icon="mdi-lock"
                                :rules="passwordRules"
                              >
                            </v-text-field>
                         <v-card-text class="text-right">
                            <v-btn text class="forgot mt-n9" router-link to="/forgotpassword">Forgot Password?</v-btn>
                        </v-card-text>
                        </v-form>
                    </v-card-text> 
                    <v-card-actions>
                        <div class="mx-auto">
                        <v-btn large dark color="#1a00d4" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" v-on:click="login()">
                            Login
                        <v-icon right>mdi-login</v-icon>
                        </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';
export default {
    components:{
        // TheNavigationPanel
    },
    name:'Login',
    data(){
        return{
            username:"",
            password:"",
            show1: false,
            loading: false,
            snackbar:false,
            snackbar1:false,
            snackmsg:false,
            usernameRules:[v => !!v || 'Email is required',
             v => /.+@.+/.test(v) || 'E-mail must be valid',],
            passwordRules:[v => !!v || 'Password is required',
            // v => v.length > 5 || 'Password cannot be less than 6 characters'],
            ],
        }
    },
    methods:{
        login(){
            if (this.$refs.form.validate()){
                this.loading = true
                this.$store.dispatch("Login", {
                "email": this.username,
                "password": this.password
                })
                .then((success)=>{
                console.log(success);
                this.loading = false
                if(this.$store.state.auth.logindetails.twoFactor===1){
                    this.$router.push('/twofactorauth');
                }else{
                    this.$router.push('/'); 
                }
                
                })
                .catch((error)=>{
                    console.log(error);
                    if(error.response.status===400){
                        this.loading = false;
                        this.snackbar = true;
                        this.offer = ''
                    }else if(error.response.status===404){
                        this.loading = false;
                        this.snackbar = true;
                        this.offer = ''
                    }
                    else{
                        this.loading = false
                        this.snackmsg = error.response.data.message
                        this.snackbar1 = true;
                    }
                
                });
            }
        }
    

    }
}
</script>
<style  scoped>
    #login{
        border-radius: 5px;
    }
    .forgot{
        text-transform: capitalize;
    }
     #backImage{
     background-color: red;
     opacity: 0.6;
     min-height: 100vh;
     
     }
</style>